import { connectMediaStore } from './withOwnReduxStore';
import { setSearchQuery, setSearchInput, unsetSearchQuery, unsetSearchInput, } from '../actions';
import { getSearchQuery, getSearchInput } from '../selectors';
export default connectMediaStore(function (state) { return ({
    searchQuery: getSearchQuery(state),
    searchInput: getSearchInput(state),
}); }, { setSearchQuery: setSearchQuery, unsetSearchQuery: unsetSearchQuery, setSearchInput: setSearchInput, unsetSearchInput: unsetSearchInput });
//# sourceMappingURL=withSearch.js.map